import {
  changeOrderPrice,
  getUsersList,
  getCompanySellerWechatInfo,
  setCompanyGroupMembers,
  getCompanyMembersList,
  getCompanyGroups,
  getRefundImage,
  getPaymentList,
  auditPayment,
  getRefundList,
  auditRefund,
  getAllCompanyInfo,
  getSellerSettlementlList,
  getSellerSettlementlData,
  getCompanyClientsCalendar,
  getCompanyDispatchList,
  getEmployeeBenefit,
  getCompanySalesData,
  sellerSettlementV3,
  getComapnyGroupDailyReport,
  getCompanyReturnVisitList,
  getCompanyPreOrderList,
  getCompanySellerWechatList,
  updateCompanySellerWechatDetail,
  getCompanyMembersDailyReport,
  getCompanyMembersNewClients,
  getSocialMediaDashboardData,
  getCompanyPaymentAccountDetail,
  getCompanySellerWechatDetailTable,
  getCompanyClientsList,
  getRolesList,
  
} from '@/api/company'

const state = {}

const mutations = {}

const actions = {
  getcompanyclientslist({commit}, param) {
    return new Promise((resolve, reject) => {
      getCompanyClientsList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getroleslist({ commit }) {
    return new Promise((resolve, reject) => {
      getRolesList().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanypaymentaccountdetail({commit}, param) {
    return new Promise((resolve, reject) => {
      getCompanyPaymentAccountDetail(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanymembersnewclients({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanyMembersNewClients(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getcompanymembersdailyreport({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanyMembersDailyReport(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatecompanysellerwechatdetail({commit}, data) {
    return new Promise((resolve, reject) => {
      updateCompanySellerWechatDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCompanySellerWechatList({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanySellerWechatList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanypreorderlist({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanyPreOrderList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanyreturnvisitlist({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanyReturnVisitList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanygroupdailyreports({commit}, data) {
    return new Promise((resolve, reject) => {
      getComapnyGroupDailyReport(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanysalesdata({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanySalesData(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sellersettlementV3({commit}, param) {
    return new Promise((resolve, reject) => {
      sellerSettlementV3(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getemployeebenefit({commit}, param) {
    return new Promise((resolve, reject) => {
      getEmployeeBenefit(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompnaydispatchlist({commit}, param) {
    return new Promise((resolve, reject) => {
      getCompanyDispatchList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompnayclientscalender({commit}, param) {
    return new Promise((resolve, reject) => {
      getCompanyClientsCalendar(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeorderprice({commit}, param) {
    return new Promise((resolve, reject) => {
      changeOrderPrice(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getuserslist({commit}, param) {
    return new Promise((resolve, reject) => {
      getUsersList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanysellerwechatinfo({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanySellerWechatInfo(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setcompanygroupmembers({commit}, data) {
    return new Promise((resolve, reject) => {
      setCompanyGroupMembers(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanymembers({commit}) {
    return new Promise((resolve, reject) => {
      getCompanyMembersList().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanygroups({commit}) {
    return new Promise((resolve, reject) => {
      getCompanyGroups().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getrefundimae({commit}, refundid) {
    return new Promise((resolve, reject) => {
      getRefundImage(refundid).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getallcompanyinfo({commit}, data) {
    return new Promise((resolve, reject) => {
      getAllCompanyInfo(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getpaymentlist({commit}, data) {
    return new Promise((resolve, reject) => {
      getPaymentList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  auditpayment({commit}, data) {
    return new Promise((resolve, reject) => {
      auditPayment(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  auditrefund({commit}, data) {
    return new Promise((resolve, reject) => {
      auditRefund(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getrefundlist({commit}, param) {
    return new Promise((resolve, reject) => {
      getRefundList(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getsellersettlementlist() {
    return new Promise((resolve, reject) => {
      getSellerSettlementlList().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getsellersettlementdata({commit}, id) {
    return new Promise((resolve, reject) => {
      getSellerSettlementlData(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getsocialmediadashboarddata({commit}, data) {
    return new Promise((resolve, reject) => {
      getSocialMediaDashboardData(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanysellerwechatdetailtable({commit}, data) {
    return new Promise((resolve, reject) => {
      getCompanySellerWechatDetailTable(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
